import { pb } from './pocketbase';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const checkSessionCode = async (sessionCode, studentId, attendance) => {
  
  console.log("sessionCode", sessionCode)
  console.log("StudentId", studentId)
  console.log("Attendance", attendance)
  console.log("Attendance session_id:", attendance?.session_id)
  console.log("Attendance id:", attendance?.id)
  
  try {
    const response = await axios.post(`${API_BASE_URL}/api/check-session-code`, {
      sessionCode,
      studentId,
      attendance
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pb.authStore.token
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la vérification du code de session:', error);
    
    // Axios lance une erreur pour les codes 4xx/5xx - extraire la réponse
    if (error.response && error.response.data) {
      return {
        success: false,
        error: error.response.data.error || 'Erreur lors de la vérification du code',
        code: error.response.data.code || 'SERVER_ERROR'
      };
    }
    
    return {
      success: false,
      error: 'Une erreur inattendue s\'est produite.',
      code: 'NETWORK_ERROR'
    };
  }
};


export const checkSessionQr = async (qrToken, studentId, attendance) => {
  
  console.log("qrToken", qrToken)
  console.log("StudentId", studentId)
  console.log("Attendance", attendance)
  
  try {
    const response = await axios.post(`${API_BASE_URL}/api/check-session-qr`, {
      qrCode: qrToken,
      studentId,
      attendance
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pb.authStore.token
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la vérification du QR code:', error);
    
    // Axios lance une erreur pour les codes 4xx/5xx - extraire la réponse
    if (error.response && error.response.data) {
      return {
        success: false,
        error: error.response.data.error || 'Erreur lors de la vérification du QR code',
        code: error.response.data.code || 'SERVER_ERROR'
      };
    }
    
    return {
      success: false,
      error: 'Une erreur inattendue s\'est produite.',
      code: 'NETWORK_ERROR'
    };
  }
};


